<template>
	<div
		class="primary-input"
		:class="{
			'primary-input--icon': icon,
			'primary-input--disabled': disabled,
			'primary-input--focused': focused,
			'primary-input--error': error,
			'primary-input--not-empty': value != '' && value !== undefined,
			'primary-input--no-float': noFloat,
		}"
	>
		<textarea
			ref="input"
			:id="id"
			class="input-field textarea"
			:class="{
				'input-field--valid': !error,
				'input-field--invalid': error,
				'input-field--empty': value == '',
			}"
			:placeholder="placeholder"
			:required="required"
			:disabled="disabled"
			:readonly="readonly"
			:minlength="minlength"
			:maxlength="maxlength"
			:inputmode="inputmode"
			:pattern="pattern"
			:value="value"
			:autocomplete="autocomplete"
			@input="onInput"
			@focus="onFocus"
			@blur="onBlur"
			@keyup="onKeyup"
			@keydown="onKeydown"
		/>
		<label
			 :for="id"
			 class="input-label"
			 :class="{
				 'label-w-icon': icon,
			 }"
			 v-if="label"
		>
			<span
				v-if="labelOption"
			>
				<span
					v-html="label"
				/>
				<span
					class="optional"
					v-html="labelOption"
				/>
			</span>
			<span
				v-else
				v-html="label"
			/>
		</label>
		<component
			class="primary-input__icon"
			v-if="icon"
			:is="iconComponent(icon)"
		/>
		<span
			v-if="showCharsleft && maxlength"
			class="primary-input__charsleft"
			v-html="charsLeftText"
		/>
	</div>
</template>

<script>
export default {
	props: {
		id: String,
		value: Number | String,
		placeholder: String,
		required: Boolean,
		disabled: Boolean,
		readonly: Boolean,
		maxlength: Number,
		showCharsleft: Boolean,
		minlength: Number,
		inputmode: String,
		pattern: String,
		label: String,
		labelOption: String,
		autocomplete: String,
		icon: String,
		error: Boolean,
    noFloat: Boolean
	},
	data() {
		return {
			focused: false,
		}
	},
	computed: {
		charsLeft() {
			if (this.maxlength) {
				return this.maxlength - (this.value?.toString().length || 0)
			}
			return 0
		},
		charsLeftText() {
			return this.$t('forms.labels.charsLeft', { count: this.charsLeft })
		}
	},
	model: {
		prop: 'value',
		event: 'input'
	},
	methods: {
		focus() {
			this.$refs.input.focus();
		},
		onInput(e) {
			this.$emit('input', e.target.value);
		},
		onFocus(e) {
			this.focused = true;
			this.$emit('focus', e);
		},
		onBlur(e) {
			this.focused = false;
			this.$emit('blur', e);
		},
		onKeyup(e) {
			this.$emit('keyup', e);
		},
		onKeydown(e) {
			this.$emit('keydown', e);
		},
	},
}
</script>

<style>

</style>
